module.exports = __webpack_public_path__ + "h5/img/huanzhe@2x.00263dfa.png";